module.exports = __webpack_public_path__ + "media/images/scoreBet__scoreDown--inactive-6fb1749ae1b34ab28de3305fdbd567d6.png";